<template>
  <div class="container">
    <div class="columns">
      <div class="column ls-left-column">
        <div class="container">
          <div class="ls-update-payment-screen--back-wrapper" test-id="back" @click="goBack">
            <div class="ls-update-payment-screen--chevron"><LsIcon type="chevron" size="md" /></div>
            <span class="ls-update-payment-screen--back">BACK</span>
          </div>

          <h1>Update Payment Method</h1>

          <form novalidate @submit.prevent="updatePayment">
            <div class="columns">
              <div class="column">
                <label>Card Number</label>
                <div id="card-number" class="stripe-card-input"></div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="columns is-mobile">
                  <div class="column">
                    <label>Exp. Month/Year</label>
                    <div id="card-expiry" class="stripe-card-input"></div>
                  </div>
                </div>
              </div>
              <div class="column">
                <label>CVC (on back)</label>
                <div id="card-cvc" class="stripe-card-input"></div>
              </div>
            </div>
            <LsBalanceWillBeProcessedNotice
              test-id="profile_update_payment_view--balance_will_be_processed_notice"
              origin="profile_update_payment_view"
              :balance="getAccountBalance"
            />
            <div class="columns">
              <div class="column button-wrapper">
                <LsButton
                  type="submit"
                  bg-color="primary"
                  text="update payment method"
                  track-id="update_credit_card_modal-update"
                  :loading="profile.loadingStatus.isUpdating"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LsIcon, LsButton } from '@/components/common';
import { loadStripe } from '@stripe/stripe-js';
import { lsDateHelpers } from 'ls-vue-common';
import { mapActions, mapState } from 'vuex';
import { PROFILE__UPDATE_PAYMENT } from '@/store/types';
import { LsBalanceWillBeProcessedNotice } from '@/components';

export default {
  name: 'ProfileUpdatePaymentView',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsIcon,
    LsButton,
    LsBalanceWillBeProcessedNotice,
  },
  data() {
    return {
      stripe: null,
      stripeElements: null,
      card: null,
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
    };
  },
  computed: {
    ...mapState(['auth', 'profile']),
    getAccountBalance() {
      const { customer } = this.auth.user;
      return (customer || {}).balance || 0;
    },
    getMonths() {
      return lsDateHelpers.getArrayOfMonths();
    },
    getYears() {
      return lsDateHelpers.getArrayOfNext20Years();
    },
  },
  async mounted() {
    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
    this.stripeElements = this.stripe.elements();
    const style = {
      base: {
        color: '#4a4a4a',
        fontFamily: 'Montserrat,Roboto,Arial,sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };
    this.cardNumber = this.stripeElements.create('cardNumber', { style });
    this.cardNumber.mount('#card-number');
    this.cardExpiry = this.stripeElements.create('cardExpiry', { style });
    this.cardExpiry.mount('#card-expiry');
    this.cardCvc = this.stripeElements.create('cardCvc', { style });
    this.cardCvc.mount('#card-cvc');
  },
  methods: {
    ...mapActions([PROFILE__UPDATE_PAYMENT]),
    goBack() {
      this.$router.back();
    },
    async updatePayment() {
      this[PROFILE__UPDATE_PAYMENT]({
        stripe: this.stripe,
        cardNumber: this.cardNumber,
        onSuccess: this.goBack,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  padding: 20px 0;
  font-weight: normal;
}

.button-wrapper {
  padding: 30px 0;
}

form {
  max-width: 50%;
}

.ls-update-payment-screen--back-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.ls-update-payment-screen--chevron {
  transform: rotate(180deg) translateY(2px);
}

.ls-update-payment-screen--back {
  color: $primary;
  font-weight: bold;
  position: relative;
}

label {
  font-weight: bold;
  font-size: 1.4rem;
  color: #4a4a4a;
  margin-bottom: 0.5em;
  font-family: 'Montserrat', 'Roboto', Arial, sans-serif;
}

.stripe-card-input {
  border: 1px solid;
  border-color: $theme-color-primary;
  padding: 6px;
}

@media (max-width: $mobile-max-width) {
  form {
    max-width: 100%;
  }
}
</style>
